import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "patientBalance",
    "newPatientBalance",
    "percentDiscount",
    "offerType",
    "negotiationFailedContainer",
    "negotiationSucceededContainer"
  ]

  updatePercentDiscount() {
    if (this.patientBalanceTarget.value != '' && this.newPatientBalanceTarget.value != '') {
      var percent = 100.0 * (1.0 - (this.newPatientBalanceTarget.value / this.patientBalanceTarget.value));
      // Do NOT round the savings percent.  It may look pretty, but it can cause the dollar amount
      // to be adjusted using this rounded percent, which can prevent you from entering a specific
      // dollar amount.
      // percent = Math.round(percent * 10.0) / 10.0;
      this.percentDiscountTarget.value = percent;
    }
  }

  updateNewPatientBalance() {
    if (this.patientBalanceTarget.value != '' && this.percentDiscountTarget.value != '') {
      this.newPatientBalanceTarget.value = this.patientBalanceTarget.value * (100.0 - this.percentDiscountTarget.value) / 100.0;

      // Trigger an event.  This is needed for form validation.
      this.newPatientBalanceTarget.dispatchEvent(new Event("change"));
    }
  }

  typeChanged() {
    if (this.offerTypeTarget.value == "payment plan") {
      this.negotiationFailedContainerTarget.classList.remove("hidden");
    } else {
      this.negotiationFailedContainerTarget.classList.add("hidden");
    }

    if (this.offerTypeTarget.value == "negotiated discount") {
      this.negotiationSucceededContainerTarget.classList.remove("hidden");
    } else {
      this.negotiationSucceededContainerTarget.classList.add("hidden");
    }
  }
}